<template>
  <div class="stoplist-category-item" :class="{
      stopped: isItemStoplisted
  }">
      <div class="item-info">
          <div>
              <img :src="productImage" class="item-image">
          </div>
          
          <div class="item-name-wrapper">
              <div class="item-stop qrw-text-description" v-if="isItemStoplisted">
                  {{ $t('stoplist.stoplisted') }}
              </div>
              <div class="item-name qrw-container-title-sm">
                  {{ product.name }}
              </div>
              <div class="item-price qrw-container-title-xs bold">
                  {{ priceToDisplay }}{{ currency.symbol }}
              </div>
          </div>
      </div>
      <div class="item-action"> 
        <BaseToggleSwitcher 
            :value="isItemStoplisted" 
            @input="val => $emit('toggle', product._id, val)"/>
        <!-- <BaseIcon icon="arrow-right" size="sm2"/> -->
      </div>
  </div>
</template>

<script>
export default {
    computed: {
        isItemStoplisted() {
            return !!this.stoplist.find(item => item.product_id == this.product._id && item.menu_id == this.menu._id);
        },
        priceToDisplay() {
            return this.product.base_price + this.product.price_groups.filter(group => {
                return group.single_select && group.items && group.items.length;
            }).reduce((acc,group) => acc + group.items[0].price, 0);
        },
        currency() {
            return this.$store.state.currency;
        },
        productImage() {
            return this.product.image_thumbnail || this.product.image || '/icons/no-dish.jpg';
        }
    },
    props: {
        product: Object,
        menu: Object,
        stoplist: Array
    }
}
</script>

<style scoped>
.stoplist-category-item {
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: center;
    align-content: center;
    width: 100%;
    background: var(--white-7-color);

    border-bottom: 1px solid var(--grey-2-color);
}

.item-info {
    width: 100%;
    display: flex;
    align-items: center;
    align-self: center;
    align-content: center;
}

.item-image {
    margin-right: 16px;
    border-radius: 4px;
    width: 40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
    display: block;
    object-fit: cover;
}

.item-name-wrapper {
    display: block;
    width: 100%;
}

.item-name {
    display: -webkit-box;
    -webkit-box-orient:vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-clamp: 2;
    -webkit-line-clamp: 2;
}

.stoplist-category-item.stopped .item-name-wrapper {
    color: var(--grey-2-color);
}
.stoplist-category-item.stopped .item-image {
    opacity: 0.4;
}

.item-action {
    color: var(--grey-2-color);
}

.item-stop {
    color: var(--red-4-color);
}
</style>